const FALLBACK = '—';

export const formatDashboardDate = (
  rawDate: number | string | undefined | null,
): string => {
  if (!rawDate || rawDate === '-' || rawDate === 'null' || rawDate === 'undefined') {
    return FALLBACK;
  }
  if (typeof rawDate === 'string' && /^\d{2}[/-]\d{2}[/-]\d{4}$/.test(rawDate.trim())) {
    return rawDate.trim();
  }
  let date: Date;
  if (typeof rawDate === 'number' || /^\d+$/.test(String(rawDate).trim())) {
    const num = Number(rawDate);
    date = num < 10000000000 ? new Date(num * 1000) : new Date(num);
  } else {
    date = new Date(rawDate);
  }
  if (Number.isNaN(date.getTime())) {
    return String(rawDate);
  }
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
